import { MantineStyleProps } from '@mantine/core';
import { DynamicUiEntitiesMetadata } from 'src/UI/dynamicUI/types';
import {
  BaseFinancialItem,
  SpendingAccount,
} from 'src/financial/financial-data/hooks/useFinancialItems';
import {
  FinancialItemGenericTable,
  formatDate,
  getFinancialItemType,
} from 'src/financial/financial-data/tables/FinancialItemGenericTable';
import { formatCurrency } from 'src/cashflows/utils';

type SpendingAccountsTableTableProps = {
  financialItems: SpendingAccount[];
  metadata: DynamicUiEntitiesMetadata;
  pl?: MantineStyleProps['pl'];
  pr?: MantineStyleProps['pr'];
  titleParts?: string[];
  onSubmit: () => void;
  onRowClick: (clickedItem: BaseFinancialItem) => void;
};
export default function SpendingAccountsTable({
  financialItems,
  metadata,
  pl = 50,
  onRowClick,
}: SpendingAccountsTableTableProps) {
  const fieldsRenderingRules = [
    {
      headerTitle: 'Description',
      sortable: true,
      sortKey: 'description',
      render: (item: SpendingAccount) => item.description,
    },
    {
      headerTitle: 'Provider',
      sortable: true,
      sortKey: 'provider',
      render: (item: SpendingAccount) => item.provider || '',
    },
    {
      headerTitle: 'Type',
      sortable: true,
      sortKey: 'type',
      render: (item: SpendingAccount) => getFinancialItemType(item, metadata),
    },
    {
      headerTitle: 'Balance date',
      sortable: true,
      sortKey: 'balanceDate',
      render: (item: SpendingAccount) => formatDate(item.balanceDate),
    },
    {
      headerTitle: 'Balance',
      sortable: true,
      sortKey: 'currentBalance',
      render: (item: SpendingAccount) => formatCurrency(item.currentBalance),
    },
  ];

  return (
    <>
      <FinancialItemGenericTable
        financialItems={financialItems}
        fieldsRenderingRules={fieldsRenderingRules}
        pl={pl}
        onRowClick={onRowClick}
      />
    </>
  );
}
